import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft, CheckCircle2, Loader2, Mail } from 'lucide-react';
import { supabase } from '../services/supabaseClient';

export default function ForgotPassword() {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [errorMsg, setErrorMsg] = useState('');
  const [sent, setSent] = useState(false);

  const handleResetRequest = async (e: React.FormEvent) => {
    e.preventDefault();
    setLoading(true);
    setErrorMsg('');

    try {
      const { error } = await supabase.auth.resetPasswordForEmail(email, {
        redirectTo: `${window.location.origin}/cowork/update-password`,
      });

      if (error) {
        setErrorMsg(error.message);
      } else {
        setSent(true);
      }
    } catch (err: unknown) {
      setErrorMsg('Ocorreu um erro ao enviar o e-mail. Tente novamente.');
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="flex-1 flex items-center justify-center min-h-[80vh] bg-gradient-to-tr from-primary-50 to-background py-16 px-4">
      <div className="max-w-md w-full bg-white rounded-3xl shadow-xl border border-primary-100 p-8 sm:p-10">
        {sent ? (
          <div className="text-center">
            <CheckCircle2 size={64} className="mx-auto mb-6 text-primary-500" />
            <h2 className="text-3xl font-extrabold text-primary-900 mb-4">E-mail enviado</h2>
            <p className="text-neutral-600 leading-relaxed">
              Verifique sua caixa de entrada e siga o link para criar uma nova senha. Confira também a pasta de spam.
            </p>
            <Link
              to="/cowork/login"
              className="inline-flex items-center gap-2 mt-8 text-primary-700 font-bold hover:text-primary-900 transition-colors"
            >
              <ArrowLeft size={18} />
              Voltar para o login
            </Link>
          </div>
        ) : (
          <>
            <div className="text-center mb-8">
              <h2 className="text-3xl font-extrabold text-primary-900 tracking-tight">Redefinir senha</h2>
              <p className="text-neutral-500 mt-2 text-sm">Informe seu e-mail para receber o link de recuperação.</p>
            </div>

            {errorMsg && (
              <div className="bg-red-50 text-red-700 p-4 rounded-xl text-sm mb-6 border border-red-200">
                {errorMsg}
              </div>
            )}

            <form onSubmit={handleResetRequest} className="space-y-6">
              <div>
                <label className="block text-sm font-semibold text-neutral-700 mb-2">E-mail de acesso</label>
                <div className="relative">
                  <span className="absolute inset-y-0 left-0 pl-3 flex items-center text-neutral-400">
                    <Mail size={18} />
                  </span>
                  <input
                    type="email"
                    required
                    value={email}
                    onChange={e => setEmail(e.target.value)}
                    placeholder="seu.email@exemplo.com"
                    className="w-full pl-10 pr-4 py-3 rounded-xl border border-neutral-300 focus:outline-none focus:ring-2 focus:ring-primary-300 focus:border-primary-500 transition-all text-neutral-800"
                  />
                </div>
              </div>

              <button
                type="submit"
                disabled={loading}
                className="w-full flex justify-center items-center gap-2 bg-primary-700 hover:bg-primary-900 text-white font-bold py-3.5 px-4 rounded-xl shadow-lg hover:shadow-xl transition-all duration-200 disabled:opacity-50"
              >
                {loading ? <Loader2 className="animate-spin" size={20} /> : null}
                {loading ? 'Enviando...' : 'Enviar link de recuperação'}
              </button>
            </form>

            <div className="mt-8 text-center">
              <Link
                to="/cowork/login"
                className="inline-flex items-center gap-2 text-sm text-primary-700 font-bold hover:text-primary-900 transition-colors"
              >
                <ArrowLeft size={16} />
                Voltar para o login
              </Link>
            </div>
          </>
        )}
      </div>
    </div>
  );
}